module.exports = __webpack_public_path__ + "static/media/cat-4.1881964e.jpg";